import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import TableCellCustom from '../../../UI/TableCellCustom';
import TableCellLeftCustom from '../../../UI/TableCellLeftCustom';
import TableCellRightCustom from '../../../UI/TableCellRightCustom';


export default function RelatorioBoletimEletivaWeb({ boletimEscolar }) {

    return (
        <>
            <Typography
                style={{
                    textAlign: 'center',
                    textDecoration: 'underline'
                }}
                variant="h6">
                Eletiva
            </Typography>
            <Table size="small" aria-label="a dense table">
                <TableHead>
                    <TableRow>
                        <TableCell rowSpan={2}>Disciplinas</TableCell>
                        <TableCellCustom colSpan={3}>1º Bim.</TableCellCustom>
                        <TableCellCustom colSpan={3}>2º Bim.</TableCellCustom>
                        <TableCellCustom colSpan={3}>3º Bim.</TableCellCustom>
                        <TableCellCustom colSpan={3}>4º Bim.</TableCellCustom>
                        <TableCell rowSpan={2}>Con. Final </TableCell>
                        <TableCell rowSpan={2}>C. H.</TableCell>
                        <TableCell rowSpan={2}>Freq.(%)</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCellLeftCustom>Conceito</TableCellLeftCustom>
                        <TableCell>Falta</TableCell>
                        <TableCell>AC</TableCell>
                        <TableCellLeftCustom>Conceito</TableCellLeftCustom>
                        <TableCell>Falta</TableCell>
                        <TableCell>AC</TableCell>
                        <TableCellLeftCustom>Conceito</TableCellLeftCustom>
                        <TableCell>Falta</TableCell>
                        <TableCell>AC</TableCell>
                        <TableCellLeftCustom>Conceito</TableCellLeftCustom>
                        <TableCell>Falta</TableCell>
                        <TableCellRightCustom>AC</TableCellRightCustom>
                    </TableRow>
                </TableHead>

                <TableBody>
                    {boletimEscolar.beletivas.map((bee, index) => (
                        <TableRow key={index}>
                            {console.log(bee)}
                            <TableCell>{bee.tdp.disciplina.descricao}</TableCell>
                            <TableCellLeftCustom>{bee.conceitoBimestral1 && bee.conceitoBimestral1.conceito ? bee.conceitoBimestral1.conceito.descricao : '--'}</TableCellLeftCustom>
                            <TableCell>{bee.totalFaltas1 ? bee.totalFaltas1 : '--'}</TableCell>
                            <TableCellRightCustom>{bee.ausenciaCompensada1 ? bee.ausenciaCompensada1 : '--'}</TableCellRightCustom>
                            <TableCell>{bee.conceitoBimestral2 && bee.conceitoBimestral2.conceito ? bee.conceitoBimestral2.conceito.descricao : '--'}</TableCell>
                            <TableCell>{bee.totalFaltas2 ? bee.totalFaltas2 : '--'}</TableCell>
                            <TableCellRightCustom>{bee.ausenciaCompensada2 ? bee.ausenciaCompensada2 : '--'}</TableCellRightCustom>
                            <TableCell>{bee.conceitoBimestral3 && bee.conceitoBimestral3.conceito ? bee.conceitoBimestral3.conceito.descricao : '--'}</TableCell>
                            <TableCell>{bee.totalFaltas3 ? bee.totalFaltas3 : '--'}</TableCell>
                            <TableCellRightCustom>{bee.ausenciaCompensada3 ? bee.ausenciaCompensada3 : '--'}</TableCellRightCustom>
                            <TableCell>{bee.conceitoBimestral4 && bee.conceitoBimestral4.conceito ? bee.conceitoBimestral4.conceito.descricao : '--'}</TableCell>
                            <TableCell>{bee.totalFaltas4 ? bee.totalFaltas4 : '--'}</TableCell>
                            <TableCellRightCustom>{bee.ausenciaCompensada4 ? bee.ausenciaCompensada4 : '--'}</TableCellRightCustom>
                            <TableCell>{bee.conceitoFinal && bee.conceitoFinal.conceito ? bee.conceitoFinal.conceito.descricao : '--'}</TableCell>
                            <TableCell>{bee.totalAulas1 + bee.totalAulas2 + bee.totalAulas3 + bee.totalAulas4}</TableCell>
                            <TableCell>{bee.frequencia}</TableCell>

                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </>
    );
}